/** Generate an example value from an OpenAPI/JSON-Schema — mirrors the backend
 *  mock generator, so the console can prefill a request body the way Swagger's
 *  "Try it out" does. Honours example/examples/default/enum, then the type. */
export function exampleFromSchema(schema: unknown, depth = 0): unknown {
  if (!schema || typeof schema !== "object" || depth > 12) return null;
  const s = schema as Record<string, unknown>;

  if ("example" in s) return s.example;
  if (Array.isArray(s.examples) && s.examples.length) return s.examples[0];
  if ("default" in s) return s.default;
  if (Array.isArray(s.enum) && s.enum.length) return s.enum[0];

  let type = s.type as string | string[] | undefined;
  if (Array.isArray(type)) type = type.find((t) => t !== "null") ?? type[0];
  if (!type && s.properties) type = "object";

  if (type === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries((s.properties as Record<string, unknown>) ?? {})) {
      out[k] = exampleFromSchema(v, depth + 1);
    }
    return out;
  }
  if (type === "array") {
    const item = exampleFromSchema(s.items ?? {}, depth + 1);
    return item != null ? [item] : [];
  }
  if (type === "string") {
    const fmt = s.format as string | undefined;
    const samples: Record<string, string> = {
      email: "user@example.com",
      "date-time": "2026-01-01T00:00:00Z",
      date: "2026-01-01",
      uuid: "00000000-0000-0000-0000-000000000000",
      uri: "https://example.com",
    };
    return (fmt && samples[fmt]) || "string";
  }
  if (type === "integer") return (s.minimum as number) ?? 0;
  if (type === "number") return (s.minimum as number) ?? 0;
  if (type === "boolean") return true;
  return null;
}
